import React, { useState, useEffect, useRef } from 'react';
import styles from "./ChatAgentUI.module.css";
import ReactMarkdown from 'react-markdown';
import { FiRefreshCw, FiSend } from 'react-icons/fi';

function ChatAgentUI() {
  const [messages, setMessages] = useState([{ role: 'bot', text: "Hei, mitä haluaisit tietää talonyhtiöösi liittyen." }]);
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = async () => {
    if (!inputValue.trim()) return;
    const userMsg = { role: 'user', text: inputValue };
    setMessages(prev => [...prev, userMsg]);
    setInputValue('');
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/chatAgent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ prompt: inputValue }),
      });
      const data = await res.json();
      if (data.response) {
        setMessages(prev => [...prev, { role: 'bot', text: data.response }]);
      } else if (data.error) {
        setMessages(prev => [...prev, { role: 'bot', text: `Virhe: ${data.error}` }]);
      } else {
        setMessages(prev => [...prev, { role: 'bot', text: `Ei vastausta.` }]);
      }
    } catch (error) {
      console.error("Chat-kutsu epäonnistui:", error);
      setMessages(prev => [...prev, { role: 'bot', text: "Virhe vastauksen hakemisessa." }]);
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleReset = () => {
    setMessages([]);
  };

  return (
    <div className={styles.chatContainer}>
      <button className={styles.resetIcon} onClick={handleReset} title="Tyhjennä keskustelu">
        <FiRefreshCw size={18} />
      </button>
     {/* Keskustelualue */}
     <div className={styles.chatMessages}>
        {messages.map((msg, i) => (
          <div key={i} className={msg.role === 'user' ? styles.userMessage : styles.botMessage}>
            {/* Varapuhdistus, jos AI-lauseke sis. markdownia */}
            <ReactMarkdown>
              {Array.isArray(msg.text) ? msg.text.join("").replace(/^,/, "") : (msg.text || "")}
            </ReactMarkdown>
          </div>
       ))}
        <div ref={bottomRef} />
      </div>

      <div className={styles.inputArea}>
        <textarea
          className={styles.textArea}
          rows={1}
          placeholder="Kirjoita viestisi..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          className={styles.sendButton}
          onClick={handleSend}
          disabled={loading}
          title="Lähetä viesti"
        >
          <FiSend size={20} />
        </button>
      </div>
    </div>
  );
}

export default ChatAgentUI;
